import { getStarted_FlexPane_Title } from 'owa-locstrings/lib/strings/getstarted_flexpane_title.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';
import { getPendingGetStartedTaskCount } from 'owa-get-started/lib/selectors/getPendingGetStartedTaskCount';
import { GetStartedPane } from 'owa-header-pane';
import { HeaderCharmType, getActiveCharm, toggleCharm } from 'owa-header-store';
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import { logUsage } from 'owa-analytics';
import { OwaWorkload, getOwaWorkload } from 'owa-workloads';
import { showO365ShellHeader } from 'owa-suite-header-apis';

@observer
export default class GetStartedCharm extends React.Component<{}, {}> {
    render() {
        if (getPendingGetStartedTaskCount() > 0 && getOwaWorkload() == OwaWorkload.Mail) {
            return (
                <div>
                    <HeaderCharm
                        key="getstarted"
                        icons={{
                            iconName: ControlIcons.Lightbulb,
                        }}
                        title={loc(getStarted_FlexPane_Title)}
                        ariaLabel={loc(getStarted_FlexPane_Title)}
                        behavior={{
                            paneComponent: showO365ShellHeader() ? null : GetStartedPane,
                            charm: HeaderCharmType.GetStartedCharm,
                            onClick: this.onGetStartedClicked,
                        }}
                        getBadgeCount={getPendingGetStartedTaskCount}
                    />
                </div>
            );
        }

        return null;
    }

    private onGetStartedClicked = () => {
        if (getActiveCharm() != HeaderCharmType.GetStartedCharm) {
            logUsage('getStartedCharmClicked', null, {
                isCore: true,
            });
        }

        if (!showO365ShellHeader()) {
            toggleCharm(HeaderCharmType.GetStartedCharm);
        }
    };
}
